module.exports = __webpack_public_path__ + "img/bank.86cd89b2.png";